import types from '../constants/actionTypes';
import { Map } from 'immutable';

const currentUser = (state, action) => {
  switch (action.type) {
    case types.dataFetching.CURRENT_USER_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.CURRENT_USER_SUCCESS:
      state = state.merge(action.payload.entities.users[action.payload.result])
                    .set('isFetching', false);
      break;
    case types.dataFetching.CURRENT_USER_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.dataFetching.SIGN_OUT_REQUEST_SUCCESS:
      state = Map();
      break;
  }
  return state;
};

export default currentUser;



/** WEBPACK FOOTER **
 ** ./reducers/currentUser.js
 **/